<template>
  <div class="editor-title">
    <h4>{{ t("message.background") }}</h4>
  </div>
  <ul>
    <li class="editor-element">
      <!-- <input type="checkbox" checked /> -->
      <!-- <i class="arrow"></i> -->
      <h2 class="row">
        <div class="col-5 text-start">{{ t("message.color") }}</div>
        <div class="col-7 text-start">
          <transition name="fade">
            <button
              class="btn btn-outline-lcn"
              v-if="!showPicker"
              :style="{}"
              @click="showPicker = true"
            >
              <font-awesome-icon
                :icon="['far', 'eye']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.fadeIn") }}
            </button>
          </transition>
        </div>
      </h2>
      <div class="content-expand">
        <transition name="fade">
          <div v-if="showPicker">
            <div class="color-picker-container">
              <MyCp
                @update="changeColor"
                @mouseup="mouseUp"
                :pColor="{ type: 'solid', color: backgroundColor }"
                :id="'color-picker-inlaybg'"
              />
            </div>
            <div class="mt-3">
              <button
                class="btn btn-outline-lcn me-2"
                @click="updateColor('background', '#ffffff')"
              >
                <font-awesome-icon
                  :icon="['fas', 'ban']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.colorRemove") }}
              </button>
              <button class="btn btn-outline-lcn" @click="showPicker = false">
                <font-awesome-icon
                  :icon="['far', 'eye-slash']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.fadeOut") }}
              </button>
            </div>
          </div>
        </transition>
      </div>
    </li>
    <li class="topic-separator">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="text-start">{{ t("message.img") }}</h2>
      <div class="content-expand">
        <div class="pb-3">
          <img
            class="p-1"
            v-for="(img, ix) in backgroundImg"
            :src="imgURL(img)"
            alt=""
            height="70"
            width="50"
            :key="ix"
            @click="updateBackgroundImg(imgURL(img), true)"
          />
        </div>
        <button
          class="btn btn-outline-lcn"
          @click="updateBackgroundImg('', false)"
        >
          <font-awesome-icon
            :icon="['fas', 'ban']"
            class="icon"
          ></font-awesome-icon>
          {{ t("message.removeImg") }}
        </button>
      </div>
    </li>
    <li class="content-item editor-element">
      <!-- <input type="checkbox" checked /> -->
      <!-- <i class="arrow"></i> -->
      <h2 class="text-start">{{ t("message.imgEdit") }}</h2>
      <div class="content-expand">
        <div class="row">
          <div class="col-5 text-start">
            <div>{{ t("message.imgScale") }}</div>
          </div>
          <div class="col-7">
            <div class="img-edit d-inline pe-2">
              <font-awesome-icon
                :icon="['fas', 'plus']"
                class="icon"
                size="lg"
                @click="scaleBgImg(10)"
              ></font-awesome-icon>
            </div>
            <div class="img-edit d-inline">
              <font-awesome-icon
                :icon="['fas', 'minus']"
                class="icon"
                size="lg"
                @click="scaleBgImg(-10)"
              ></font-awesome-icon>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5 text-start">
            <div>{{ t("message.position") }}</div>
          </div>
          <div class="col-7">
            <div class="row justify-content-center">
              <div class="col-1 img-edit" @click="setBgPos('top left')">
                <b-icon-arrow-up-left-circle></b-icon-arrow-up-left-circle>
              </div>
              <div class="col-1 img-edit" @click="setBgPos('top')">
                <b-icon-arrow-up-circle></b-icon-arrow-up-circle>
              </div>
              <div class="col-1 img-edit" @click="setBgPos('top right')">
                <b-icon-arrow-up-right-circle></b-icon-arrow-up-right-circle>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-1 img-edit" @click="setBgPos('left')">
                <b-icon-arrow-left-circle></b-icon-arrow-left-circle>
              </div>
              <div class="col-1 img-edit" @click="setBgPos('center')">
                <b-icon-circle></b-icon-circle>
              </div>
              <div class="col-1 img-edit" @click="setBgPos('right')">
                <b-icon-arrow-right-circle></b-icon-arrow-right-circle>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-1 img-edit" @click="setBgPos('bottom left')">
                <b-icon-arrow-down-left-circle></b-icon-arrow-down-left-circle>
              </div>
              <div class="col-1 img-edit" @click="setBgPos('bottom')">
                <b-icon-arrow-down-circle></b-icon-arrow-down-circle>
              </div>
              <div class="col-1 img-edit" @click="setBgPos('bottom right')">
                <b-icon-arrow-down-right-circle></b-icon-arrow-down-right-circle>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5 text-start">
            <div>{{ t("message.moveImg") }}</div>
          </div>
          <div class="col-7">
            <div class="img-edit">
              <font-awesome-icon
                :icon="['fas', 'chevron-up']"
                class="icon"
                size="lg"
                @click="setBgPos('top', -1)"
              ></font-awesome-icon>
            </div>
            <div class="img-edit d-inline pe-5">
              <font-awesome-icon
                :icon="['fas', 'chevron-left']"
                class="icon"
                size="lg"
                @click="setBgPos('left', -1)"
              ></font-awesome-icon>
            </div>
            <div class="img-edit d-inline">
              <font-awesome-icon
                :icon="['fas', 'chevron-right']"
                class="icon"
                size="lg"
                @click="setBgPos('left', 1)"
              ></font-awesome-icon>
            </div>
            <div class="img-edit">
              <font-awesome-icon
                :icon="['fas', 'chevron-down']"
                class="icon"
                size="lg"
                @click="setBgPos('top', 1)"
              ></font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import image64 from "@/modules/image64";
import { useI18n } from "vue-i18n";
import MyCp from "@/views/editors/editor-components/ColorPicker.vue";
export default {
  components: {
    MyCp,
  },
  setup() {
    const showPicker = ref(false);
    const store = useStore();
    const { t } = useI18n();
    const backgroundColor = computed(
      () => store.getters.currentBackgroundColor
    );
    const currentBackgroundImg = computed(
      () => store.getters.currentBackgroundImg
    );
    const currentBgPos = computed(() => store.getters.currentBgPos);

    function changeColor(e) {
      updateColor("background", e);
    }
    function updateColor(trigger, event) {
      //falls Object füge die richtigen Werte zu
      if (typeof event === "object") {
        store.dispatch("switchInlayBackground", event.colors.hex);
      } else {
        //ansonsten nimm den übergebenen String
        store.dispatch("switchInlayBackground", event);
      }
      updateBackgroundImg("", false);
    }

    function updateBackgroundImg(imgURL, showImg) {
      store.dispatch("displayBackgroundImg", showImg);
      if (showImg) {
        image64(
          imgURL,
          (base64Img) => {
            store.dispatch(
              "switchInlayBackgroundImg",
              "url(" + base64Img + ")"
            );
          },
          "image/png"
        );
      } else {
        store.dispatch("switchInlayBackgroundImg", "");
      }
    }

    function imgURL(img) {
      return process.env.BASE_URL + "images/background/" + img;
    }

    const backgroundImg = [
      "1.png",
      "2.png",
      "3.png",
      "4.png",
      "5.png",
      "6.png",
      "7.png",
      "8.png",
      "9.png",
      "10.png",
      "11.png",
      "12.png",
      "13.png",
    ];

    const currentStep = ref(100);

    function scaleBgImg(step) {
      if (currentStep.value + step < 10 || currentStep.value + step > 200)
        return;
      currentStep.value = currentStep.value + step;

      if (currentStep.value >= 10) {
        store.dispatch("transformBgImg", currentStep.value + "%");
      }
    }

    function setBgPos(pos, value) {
      let match = currentBgPos.value.match(/^(.+)\s*mm\s*(.+)\s*mm/);

      //Überprüft ob schon vorherige position vorhanden und verschiebt in dem Fall für Y-Achse
      if (pos == "top" && currentBgPos.value.includes("mm")) {
        store.dispatch(
          "repositionBg",
          match[1] + "mm " + (parseInt(match[2]) + value) + "mm"
        );
        //Falls keine vorherige Position vorhanden, oder nur Position über fixed pos setzt mm pos
      } else if (pos == "top" && value) {
        store.dispatch("repositionBg", "0mm " + value + "mm");
      } else if (pos == "left" && currentBgPos.value.includes("mm")) {
        store.dispatch(
          "repositionBg",
          parseInt(match[1]) + value + "mm " + match[2] + "mm"
        );
      } else if (pos == "left" && value) {
        store.dispatch("repositionBg", value + "mm 0mm");
      } else {
        store.dispatch("repositionBg", pos);
      }
    }

    function mouseUp() {
      store.dispatch("saveInlay");
    }
    return {
      store,
      backgroundColor,
      currentBackgroundImg,
      updateColor,
      updateBackgroundImg,
      backgroundImg,
      imgURL,
      scaleBgImg,
      currentStep,
      currentBgPos,
      setBgPos,
      t,
      showPicker,
      changeColor,
      mouseUp,
    };
  },
};
</script>

<style lang="scss" scoped>
.img-edit:hover {
  cursor: pointer;
}
</style>
